import React from 'react';
import { DateComponent } from 'src/components/Tag/DateComponent/DateComponent';
import { ITag } from './interfaces';
import { TagContainer } from './Tag.styles';

export const Tag = ({
  color,
  className,
  date,
  status,
  isFromMvpApp,
  ...rest
}: ITag) => {
  return (
    <TagContainer
      isFromMvpApp={isFromMvpApp}
      className={className}
      color={color}
      {...rest}
    >
      <DateComponent isFromMvpApp={isFromMvpApp} date={date} status={status} />
    </TagContainer>
  );
};
